import {OnboardingTutorialStepBackButtonStyled} from "./styled/OnboardingTutorialStepBackButtonStyled";
import {BinIcon} from "../../../../../components/icon/Icon";
import {useOnboardingTutorialContext} from "../../onboardingTutorialContext";
import {useGTMEvent} from "../../../../GoogleTagManager/googleTagManagerHooks";
import {useCallback} from "react";
import appHistory from "../../../../../app/appHistory";

export const OnboardingTutorialStepBackButton = () => {
    const {currentStepName, previousStepName} = useOnboardingTutorialContext();
    const {pushGtmEvent} = useGTMEvent({module: 'OnboardingTutorial'});
    
    const handleButtonClick = useCallback(() => {
        pushGtmEvent({
            event: 'onboarding_click',
            button: 'OnboardingTutorialStepBackButton',
            currentStepName,
            previousStepName,
        })
        appHistory.goBack();
    }, [currentStepName, previousStepName, pushGtmEvent])
    
    return (
            <OnboardingTutorialStepBackButtonStyled onClick={handleButtonClick}>
                <BinIcon
                        name="IcArrowLeft"
                        style={{fill: 'var(--icon-primary-color)'}}
                />
            </OnboardingTutorialStepBackButtonStyled>
    )
}